import i18n from "@/i18n";
import { mapActions } from "vuex";
import { SnackbarStyle } from "@/constants/constants";
import { dialogTypes } from "@/constants/dialogTypes";
import { DialogType } from "@/constants/constants";
import RusConfigurationTabComponent from "@/components/enterprise/ruses/rus-configuration/RusConfigurationTabComponent.vue";
import EventConfigurationTabComponent from "./tabs/events/EventConfigurationTabComponent.vue";
import ThingDataTabComponent from "./tabs/data/ThingDataTabComponent.vue";
import ThingTypeTabComponent from "./tabs/type/ThingTypeTabComponent.vue";
import AgroTabComponent from "./tabs/agro/AgroTabComponent.vue";
import DescriptionTabComponent from "./tabs/description/DescriptionTabComponent.vue";
import ReminderTabComponent from "./tabs/reminder/ReminderTabComponent.vue";
import GpsTabComponent from "./tabs/gps/GpsTabComponent.vue";
import FuelTabComponent from "./tabs/fuel/FuelTabComponent.vue";
import ControlTabComponent from "./tabs/control/ControlTabComponent.vue"
import { thingService } from "@/services/thing.service";
import { enterpriseService } from "@/services/enterprise.service";
import Vue from "vue";
import { ConsumptionType, TYPE_KEY } from "@colven/common-domain-lib/lib";
import CalibratorTabComponent from "./tabs/calibrator/CalibratorTabComponent.vue"
import { typeService } from "@/services/type.service";

/**
 * TO DO: revisar todo el código e implementar igual a los demás dialogs
 */
export default {
  name: "ThingDialogComponent",
  components: {
    ThingDataTabComponent,
    ThingTypeTabComponent,
    AgroTabComponent,
    RusConfigurationTabComponent,
    ReminderTabComponent,
    EventConfigurationTabComponent,
    DescriptionTabComponent,
    GpsTabComponent,
    FuelTabComponent,
    ControlTabComponent,
    CalibratorTabComponent
  },
  props: {
    // v-model injects the object to be edited into props.value
    model: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    tab: null,
    dataTab: {
      key: "thingDataTab",
      tab: i18n.t("equipment.editDialog.tabs.data"),
      tooltip: i18n.t("equipment.editDialog.tabs.dataTooltip"),
      icon: "mdi-form-textbox",
      content: {
        _uid: "oRWrTpA7h6",
        component: "ThingDataTabComponent",
        headline: "ThingDataTabComponent",
      },
      disabled: false,
      model: {
        name: null,
        identificator: null,
        color: "#0694de",
        commodatum: false,
      },
      validForm: false,
    },
    descriptionTab: {
      key: "descriptionTab",
      tab: i18n.t("equipment.editDialog.tabs.description"),
      tooltip: i18n.t("equipment.editDialog.tabs.descriptionTooltip"),
      icon: "mdi-form-textbox",
      content: {
        _uid: "94RSXuHRWS",
        component: "DescriptionTabComponent",
        headline: "DescriptionTabComponent",
      },
      disabled: false,
      model: {
        description: null,
      },
      validForm: false,
    },
    typeTab: {
      key: "thingTypeTab",
      tab: i18n.t("equipment.editDialog.tabs.type"),
      tooltip: i18n.t("equipment.editDialog.tabs.typeTooltip"),
      icon: "mdi-form-textbox",
      content: {
        _uid: "4ySl0DYm5r",
        component: "ThingTypeTabComponent",
        headline: "ThingTypeTabComponent",
      },
      disabled: false,
      model: {
        thingId: null,
        enterpriseId: null,
        countryId: null,
        groupId: null,
        sectorId: null,
        activityId: null,
        fleetId: null,
        types: [],
        typeId: null,
        loadingTypes: false,
        update: false,
        isClone: false,
        ignoreStoppedForLackEmptyBox: false,
      },
      validForm: false,
    },
    agroTab: {
      key: "agroTab",
      tab: i18n.t("equipment.editDialog.tabs.agro"),
      tooltip: i18n.t("equipment.editDialog.tabs.agroTooltip"),
      icon: "mdi-form-textbox",
      content: {
        _uid: "LqwMvfa848",
        component: "AgroTabComponent",
        headline: "AgroTabComponent",
      },
      disabled: true,
      model: {
        enterpriseIdSelected: null,
        typeKeySelected: null,
        harvestFrontId: null,
        originWorkWidth: null,
        hasOnBoardMonitor: null,
        boxQuantity: null,
      },
      validForm: false,
    },
    fuelTab: {
      key: "fuelTab",
      tab: i18n.t("equipment.editDialog.tabs.fuel"),
      tooltip: i18n.t("equipment.editDialog.tabs.fuelTooltip"),
      icon: "mdi-gas-station-outline",
      content: {
        _uid: "1pWSA0a0Za",
        component: "FuelTabComponent",
        headline: "FuelTabComponent",
      },
      disabled: false,
      model: {
        consumption: {},
      },
      validForm: true, // se modifica a true para tratar de evitar que triggeree alguna validación
    },
    gpsTab: {
      key: "gpsTab",
      tab: i18n.t("equipment.editDialog.tabs.gps"),
      tooltip: i18n.t("equipment.editDialog.tabs.gpsTooltip"),
      icon: "mdi-file-cog-outline",
      content: {
        _uid: "GpiyL6n24n",
        component: "GpsTabComponent",
        headline: "GpsTabComponent",
      },
      disabled: false,
      model: {
        gpsId: null,
      },
      validForm: false,
    },
    reminderTab: {
      key: "reminderTab",
      tab: i18n.t("equipment.editDialog.tabs.reminder"),
      tooltip: i18n.t("equipment.editDialog.tabs.reminderTooltip"),
      icon: "mdi-file-cog-outline",
      content: {
        _uid: "OXw07LXy6D",
        component: "ReminderTabComponent",
        headline: "ReminderTabComponent",
      },
      disabled: false,
      model: {
        // remindersData: [],
        reminderBy: [],
        update: false,
      },
      validForm: false,
    },
    rusTab: {
      key: "thingRusesTab",
      tab: i18n.t("enterprise.editDialog.tabs.ruses"),
      tooltip: i18n.t("enterprise.editDialog.tabs.rusesTooltip"),
      icon: "mdi-file-cog-outline",
      content: {
        _uid: "g3jfYsIluO",
        component: "RusConfigurationTabComponent",
        headline: "RusConfigurationTabComponent",
      },
      disabled: true,
      model: {
        ruses: [],
        rusKeys: [],
        rusConfigurations: {},
        enterpriseRusConfigurations: {},
        hideTypeSelector: true,
        isThingABM: true,
      },
      validForm: false,
      isThingABM: true,
    },
    eventTab: {
      key: "enterpriseDialogEventsTab",
      tab: i18n.t("enterprise.editDialog.tabs.events"),
      tooltip: i18n.t("enterprise.editDialog.tabs.eventsTooltip"),
      icon: "mdi-state-machine",
      content: {
        _uid: "1pWSA0a0Ze",
        component: "EventConfigurationTabComponent",
        headline: "EventConfigurationTabComponent",
      },
      disabled: true,
      model: {
        eventConfigurations: [],
        enterpriseId: null,
        hideTypeSelector: true,
      },
      validForm: false,
    },
    controlTab: {
      key: "controlTab",
      tab: i18n.t("equipment.editDialog.tabs.controlLevel"),
      tooltip: i18n.t("equipment.editDialog.tabs.controlLevelTooltip"),
      icon: "mdi-state-machine",
      content: {
        _uid: "2cXSB0g0Zu", // modificar
        component: "controlTabComponent",
        headline: "controlTabComponent",
      },
      disabled: true,
      enterpriseSupport: false,
      setControlValues: false,
      disableReportSelector: false,
      thingSupport: false,
      model: {
        serviceType: "LIGHT_TRANSPORT",
        reportBy: "",
        varilla: {}
      },
      validForm: true, // se modifica a true para tratar de evitar que triggeree alguna validación
    },
    calibratorTab: {
      key: "calibratorTab",
      tab: i18n.t("equipment.editDialog.tabs.caliper"),
      tooltip: i18n.t("equipment.editDialog.tabs.caliperTooltip"),
      icon: "mdi-swap-vertical-circle",
      content: {
        _uid: "2jXSB0g0Zu",
        component: "calibratorTabComponent",
        headline: "calibratorTabComponent",
      },
      disabled: true,
      model: {
        caliper: {}
      },
      validForm: false,
      isLegacy: false
    },
    items: [],
    validationRules: {
      required: (value) => !!value || `${i18n.t("required")}`,
      greaterThanEqual(minValue) {
        return (value) =>
          value === "" ||
          value == null ||
          minValue == null ||
          Number(value) >= Number(minValue) ||
          `${i18n.t("error.greaterThanEqual", { value: minValue })}`
      },
      lessThanEqual(maxValue) {
        return (value) =>
          value == null ||
          maxValue == null ||
          Number(value) <= Number(maxValue) ||
          `${i18n.t('error.lessThanEqual', { value: maxValue })}`
      },
      noDuplicateProperty: (allValues, value) =>
        !(allValues.filter((v) => v === value).length > 1) ||
        `${i18n.t("error.duplicateProperty")}`,
      shortDecimalNumber: (value) =>
        /^\d*(\.\d{1})?\d{0,1}$/.test(value) ||
        `${i18n.t('error.shortDecimalNumber', { value: value })}`,
      leftZeroNumber: (value) =>
        !/^0+(?!$)/.test(value) ||
        `${i18n.t('error.leftZeroNumber', { value: value })}`,
    },
    resetForms: false,
  }),
  computed: {
    disableSaveBtn() {
      return (
        !this.rusTab.validForm ||
        !this.validRuses ||
        !this.dataTab.validForm ||
        !this.typeTab.validForm ||
        !this.agroTab.validForm ||
        !this.gpsTab.validForm ||
        !this.descriptionTab.validForm ||
        !this.fuelTab.validForm ||
        !this.controlTab.validForm ||
        !this.calibratorTab.validForm
      );
    },
    validRuses() {
      if (this.rusTab.model.rusConfigurations) {
        let valid = true;
        Object.values(this.rusTab.model.rusConfigurations).forEach(
          (rusConfiguration) => {
            const allValues = rusConfiguration.map((c) => c.property);
            rusConfiguration.forEach((config) => {
              if (!config.property) {
                valid = false;
                return;
              }
              if (allValues.filter((v) => v === config.property).length > 1) {
                valid = false;
                return;
              }
            });
            if (!valid) return;
          }
        );
        return valid;
      }
      return true;
    },
  },
  beforeMount() {
    if (this.model.varilla && Object.keys(this.model.varilla).length > 0) {
      this.controlTab.isLegacy = true;
      this.controlTab.setControlValues = true;
      this.controlTab.model.varilla = this.model.varilla;
      this.controlTab.disableReportSelector = (this.model.reportBy === 'ODOMETER' || this.model.reportBy === 'HOURMETER');
      this.controlTab.model.reportBy = this.model.reportBy;
      this.controlTab.model.serviceType = this.model.serviceType;
    }

    this.items = [
      this.dataTab,
      this.gpsTab,
      this.typeTab,
      this.agroTab,
      this.fuelTab,
      this.rusTab,
      this.eventTab,
      this.reminderTab,
      this.controlTab,
      this.descriptionTab,
      this.calibratorTab
    ];
    this.getRuses();
    this.getRusKeys();
    this.getEnterpriseConfiguration(this.model.enterpriseId, this.model.typeId);
    this.typeTab.model.update = this.model.update;
    if(this.model.update) {
      this.agroTab.model.currentHarvestFrontId = this.model.harvestFrontId;
    }
    this.typeTab.model.isClone = this.model.isClone;
    this.typeTab.model.thingId = this.model._id;

    this.calibratorTab.model.caliper = this.model.caliper;
  },
  mounted() {
    if (this.model) {
      this.rusTab.model.rusConfigurations = this.model.config;
      this.getEnterpriseConfiguration(
        this.model.enterpriseId,
        this.model.typeId
      );
      this.eventTab.model.eventConfigurations = this.model.eventConfiguration || [];
      this.eventTab.model.enterpriseId = this.model.enterpriseId;

      this.dataTab.model.name = this.model.name;
      this.dataTab.model.identificator = this.model.identificator;
      this.dataTab.model.color =
        this.model.color != null ? this.model.color : "#0694de";
      this.dataTab.model.commodatum = this.model.commodatum;

      this.typeTab.model.enterpriseId = this.model.enterpriseId;
      this.typeTab.model.countryId = this.model.countryId;
      this.typeTab.model.groupId = this.model.groupId;
      this.typeTab.model.sectorId = this.model.sectorId;
      this.typeTab.model.activityId = this.model.currentActivity;
      this.typeTab.model.fleetId = this.model.fleetId;
      this.typeTab.model.typeId = this.model.typeId;
      this.typeTab.model.ignoreStoppedForLackEmptyBox = this.model.ignoreStoppedForLackEmptyBox;
      this.typeTab.model.sendNewsToPims = this.model.sendNewsToPims;

      this.agroTab.model.enterpriseIdSelected = this.model.enterpriseId;
      this.agroTab.model.typeKeySelected = this.model.typeKey;
      this.agroTab.model.harvestFrontId = this.model.harvestFrontId;
      this.agroTab.model.originWorkWidth = this.model.originWorkWidth
      this.agroTab.model.hasOnBoardMonitor = this.model.hasOnBoardMonitor;
      this.agroTab.model.boxQuantity = this.model.boxQuantity;

      this.descriptionTab.model.description = this.model.description;

      this.gpsTab.model.gpsId = this.model.gpsId;

      this.reminderTab.model.reminderBy = this.model.reminderBy;

      this.fuelTab.model.consumption = this.model.consumption;
    }
  },
  methods: {
    /**
     * actions del breadcrumb
     */
    ...mapActions("breadcrumbs", ["pushBread", "pullBread"]),
    /**
     * actions del snackbar
     */
    ...mapActions("snackbar", ["showSnackbar", "closeSnackbar"]),
    /**
     * actions del dialog
     */
    ...mapActions("dialog", ["openDialog", "closeDialog"]),
    getRuses() {
      thingService.getRuses().then((response) => {
        this.rusTab.model.ruses.push(...response);
      });
    },
    getRusKeys() {
      thingService.getRusKeys().then((response) => {
        this.rusTab.model.rusKeys.push(...response);
        this.rusTab.model.rusKeys.sort(function sort(a, b) {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          } else {
            return 0;
          }
        });
      });
    },
    getEnterpriseConfiguration(enterpriseId, typeId) {
      if (enterpriseId && typeId) {
        thingService
          .getEnterpriseRusConfiguration(enterpriseId, typeId)
          .then((response) => {
            this.rusTab.model.enterpriseRusConfigurations = response;
          });
        thingService
          .getEnterpriseEventConfiguration(enterpriseId, typeId)
          .then((response) => {
            this.eventTab.model.enterpriseEventConfiguration = response;
          });
      }
    },
    /**
     * Resetea los campos del formulario de creación/actualización
     */
    resetFields() {
      // para limpiar las validaciones en los formularios
      this.resetForms = true;
      const that = this;
      Vue.nextTick(function () {
        that.resetForms = false;
      });
    },
    clickOutside() {
      this.cancel();
    },
    cancel() {
      this.pullBread(dialogTypes.THING.key);
      this.resetFields();
    },
    async save() {
      this.$emit('validateForm')

      const thingDto = await this.getThingDto();
      if (this.model.isClone) {
        thingDto._id = null;
      }
      const isGpsAlreadyAssigned = await thingService.isGpsAlreadyAssigned(
        thingDto.gpsId,
        thingDto._id
      );
      if (isGpsAlreadyAssigned) {
        this.openDialog({
          title: this.$t("equipment.reassignGpsId"),
          text: this.$t("equipment.reassignGpsIdConfirmation", {
            identificator: thingDto.identificator,
          }),
          type: DialogType.QUESTION,
          overlayOpacity: 0.5,
          actionButtons: true,
          yesAction: async () => {
            if (this.model.update) {
              // update
              thingDto.consumption = this.setConsumption(thingDto.consumption);
              thingService.update(thingDto).then((result) => {
                if (result) {
                  this.showSnackbar({
                    visible: true,
                    text: this.$t("equipment.successUpdateMessage"),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS,
                  });
                  this.$emit("commitThing");
                  this.cancel();
                }
              });
            } else {
              // CREATE
              thingDto.consumption = this.setConsumption(thingDto.consumption);
              thingService.create(thingDto).then((result) => {
                if (result) {
                  this.showSnackbar({
                    visible: true,
                    text: this.$t("equipment.successCreateMessage"),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS,
                  });
                  this.$emit("commitThing");
                  this.cancel();
                }
              });
            }
          },
          noAction: () => { },
        });
      } else {
        if (this.model.update) {
          // update
          thingDto.consumption = this.setConsumption(thingDto.consumption);
          thingService.update(thingDto).then((result) => {
            if (result) {
              this.showSnackbar({
                visible: true,
                text: this.$t("equipment.successUpdateMessage"),
                timeout: 6000,
                style: SnackbarStyle.SUCCESS,
              });
              this.$emit("commitThing");
              this.cancel();
            }
          });
        } else {
          // CREATE
          thingDto.consumption = this.setConsumption(thingDto.consumption);
          thingService.create(thingDto).then((result) => {
            if (result) {
              this.showSnackbar({
                visible: true,
                text: this.$t("equipment.successCreateMessage"),
                timeout: 6000,
                style: SnackbarStyle.SUCCESS,
              });
              this.$emit("commitThing");
              this.cancel();
            }
          });
        }
      }
    },
    async getThingDto() {
      // Se eliminan los rus que no poseen propiedades
      Object.keys(this.rusTab.model.rusConfigurations).forEach((rus) => {
        if (this.rusTab.model.rusConfigurations[rus].length <= 0) {
          delete this.rusTab.model.rusConfigurations[rus];
        } else {
          // Se eliminan las propiedades con valor == "", null o undefined
          this.rusTab.model.rusConfigurations[rus].forEach((el) => {
            if (!el.adjustment) delete el.adjustment;
            if (!el.unit) delete el.unit;
            if (!el.mapTo) delete el.mapTo;
          });
        }
      });

      const types = await typeService.getAllForSelector();

      const selectedType = types.find((type) => type._id === this.typeTab.model.typeId);

      
      return {
        _id: this.model._id,
        name: this.dataTab.model.name,
        description: this.descriptionTab.model.description,
        commodatum: this.dataTab.model.commodatum,
        typeId: this.typeTab.model.typeId,
        gpsId: this.gpsTab.model.gpsId,
        enterpriseId: this.typeTab.model.enterpriseId,
        countryId: this.typeTab.model.countryId,
        currentActivity: this.typeTab.model.activityId,
        harvestFrontId: this.agroTab.model.harvestFrontId,
        fleetId: this.typeTab.model.fleetId,
        sectorId: this.typeTab.model.sectorId,
        groupId: this.typeTab.model.groupId,
        identificator: this.dataTab.model.identificator?.trim(),
        color: this.dataTab.model.color,
        // features: null,
        hasOnBoardMonitor: this.agroTab.model.hasOnBoardMonitor,
        originWorkWidth: this.agroTab.model.originWorkWidth,
        config:
          Object.keys(this.rusTab.model.rusConfigurations)?.length === 0
            ? {}
            : this.rusTab.model.rusConfigurations,
        boxQuantity: this.agroTab.model.boxQuantity,
        eventConfiguration:
          this.eventTab.model.eventConfigurations?.length === 0
            ? undefined
            : this.eventTab.model.eventConfigurations,
        reminderBy: this.reminderTab.model.reminderBy,
        consumption: this.fuelTab.model.consumption,
        varilla: this.controlTab.disabled  || !this.controlTab.setControlValues ? null : this.controlTab.model.varilla,
        serviceType: this.controlTab.disabled || !this.controlTab.setControlValues ? null : this.controlTab.model.serviceType,
        reportBy: this.controlTab.disabled || !this.controlTab.setControlValues ? null : this.controlTab.model.reportBy,
        caliper: this.calibratorTab.model.caliper,
        ignoreStoppedForLackEmptyBox: this.typeTab.model.ignoreStoppedForLackEmptyBox,
        ...((selectedType.key === "CANE_EQUIPMENT" || selectedType.key === "TRUCK") && { sendNewsToPims: this.typeTab.model.sendNewsToPims || false })
      };
    },
    /**
     * Captura un evento cuando se modifica la selección de tipos de equipos
     * @param {*} typeKey
     */
    updateTypeKeySelected(typeKey) {
      if (typeKey != null) {
        this.agroTab.disabled = false;
        this.agroTab.model.typeKeySelected = typeKey;
        if (typeKey == TYPE_KEY.LOGISTIC_TRUCK) {
          this.controlTab.thingSupport = true
          this.calibratorTab.disabled = false
        }
        else {
          this.controlTab.thingSupport = false
          this.calibratorTab.disabled = true

        }
      } else {
        this.agroTab.disabled = true;
        this.agroTab.model.typeKeySelected = null;
      }
    },
    /**
     * Captura un evento cuando se modifica la selección de empresas,
     * para habilitar/deshabilitar los diferentes tabs
     * @param {*} enterpriseId
     */
    async updateEnterpriseIdSelected(enterpriseId) {
      if (enterpriseId != null) {
        this.rusTab.disabled = false;
        this.eventTab.disabled = false;
        this.agroTab.model.enterpriseIdSelected = enterpriseId;
        const enterprise = await enterpriseService.findOne(enterpriseId);
        if (enterprise.varillaTypes) {
          const varillaType = enterprise.varillaTypes.find(element => element == TYPE_KEY.LOGISTIC_TRUCK)
          varillaType ?
            this.controlTab.enterpriseSupport = true : this.controlTab.enterpriseSupport = false



        }
        else {
          this.controlTab.enterpriseSupport = false
        }

      } else {
        this.rusTab.disabled = true;
        this.eventTab.disabled = true;
        this.agroTab.model.enterpriseIdSelected = null;
      }
    },

    /**
     *  Busca la configuracion de RUS y Eventos cada vez que cambia la enterprise o el type
     */
    updateConfiguration() {
      if (this.typeTab.model.enterpriseId && this.typeTab.model.typeId) {
        this.getEnterpriseConfiguration(this.typeTab.model.enterpriseId, this.typeTab.model.typeId);
      }
    },
    /**
     * configura el objeto consumption para ser guardado/actualizado
     * @param {*} consumption
     */
    setConsumption(consumption) {
      if (!consumption.type || !consumption.litres) {
        return 0;
      }
      switch (parseInt(consumption.type, 10)) {
        case ConsumptionType.HS:
          consumption = {
            type: ConsumptionType.HS,
            pricePerLitre: parseFloat(consumption.pricePerLitre),
            litres: [{ litres: consumption.litres }],
          };
          break;
        case ConsumptionType.HS_SPEED:
          consumption = {
            type: ConsumptionType.HS_SPEED,
            pricePerLitre: parseFloat(consumption.pricePerLitre),
            litres: [
              {
                litres: consumption.litres,
                from: consumption.from,
                to: consumption.to,
              },
            ],
          };
          break;
        case ConsumptionType.KM:
          consumption = {
            type: ConsumptionType.KM,
            pricePerLitre: parseFloat(consumption.pricePerLitre),
            litres: [{ litres: consumption.litres }],
          };
          break;
        case ConsumptionType.KM_RPM:
          consumption = {
            type: ConsumptionType.KM_RPM,
            pricePerLitre: parseFloat(consumption.pricePerLitre),
            litres: [
              {
                litres: consumption.litres,
                from: consumption.from,
                to: consumption.to,
              },
            ],
          };
          break;
        case ConsumptionType.KM_SPEED:
          consumption = {
            type: ConsumptionType.KM_SPEED,
            pricePerLitre: parseFloat(consumption.pricePerLitre),
            litres: [
              {
                litres: consumption.litres,
                from: consumption.from,
                to: consumption.to,
              },
            ],
          };
          break;
      }
      return consumption;
    },
    enableVarilla() {
      this.controlTab.setControlValues = !this.controlTab.setControlValues
    }
  },
  watch: {
    'controlTab.enterpriseSupport': function () {
      if (this.controlTab.isLegacy) {
        this.controlTab.disabled = false;
        this.controlTab.isLegacy = false;
      }
      else {
        this.controlTab.disabled = !(this.controlTab.thingSupport && this.controlTab.enterpriseSupport);
      }
    },
    'controlTab.thingSupport': function () {
      if (this.controlTab.isLegacy) {
        this.controlTab.disabled = false;
        this.controlTab.isLegacy = false;
      }
      else {
        this.controlTab.disabled = !(this.controlTab.thingSupport && this.controlTab.enterpriseSupport);
      }
    }
  }
}
